export function resolveMarketingListsOrderInfo(sortField, sortDirection) {
    const field = typeof sortField === 'string' ? sortField.trim() : '';
    if (!field) {
        return null;
    }

    let direction = '';
    if (sortDirection === 0) {
        direction = 'ASC';
    } else if (sortDirection === 1) {
        direction = 'DESC';
    } else if (typeof sortDirection === 'string') {
        direction = sortDirection.trim().toUpperCase();
    }

    if (direction !== 'ASC' && direction !== 'DESC') {
        return null;
    }

    return {
        Field: field,
        Direction: direction,
    };
}
